"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "JobsMap", {
    enumerable: true,
    get: function() {
        return JobsMap;
    }
});
const _common = require("@nestjs/common");
const _duplicateprocessor = require("~/modules/jobs/jobs/export-import/duplicate.processor");
const _atimportprocessor = require("~/modules/jobs/jobs/at-import/at-import.processor");
const _metasyncprocessor = require("~/modules/jobs/jobs/meta-sync/meta-sync.processor");
const _sourcecreateprocessor = require("~/modules/jobs/jobs/source-create/source-create.processor");
const _sourcedeleteprocessor = require("~/modules/jobs/jobs/source-delete/source-delete.processor");
const _webhookhandlerprocessor = require("~/modules/jobs/jobs/webhook-handler/webhook-handler.processor");
const _dataexportprocessor = require("~/modules/jobs/jobs/data-export/data-export.processor");
const _thumbnailgeneratorprocessor = require("~/modules/jobs/jobs/thumbnail-generator/thumbnail-generator.processor");
const _attachmentcleanup = require("~/modules/jobs/jobs/attachment-clean-up/attachment-clean-up");
const _initmigrationjobs = require("~/modules/jobs/migration-jobs/init-migration-jobs");
const _useworkerprocessor = require("~/modules/jobs/jobs/use-worker/use-worker.processor");
const _dataexportcleanupprocessor = require("~/modules/jobs/jobs/data-export-clean-up/data-export-clean-up.processor");
const _attachmenturluploadprocessor = require("~/modules/jobs/jobs/attachment-url-upload/attachment-url-upload.processor");
const _Jobs = require("~/interface/Jobs");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let JobsMap = class JobsMap {
    get _jobMap() {
        return {
            [_Jobs.JobTypes.DuplicateBase]: {
                this: this.duplicateProcessor,
                fn: 'duplicateBase'
            },
            [_Jobs.JobTypes.DuplicateModel]: {
                this: this.duplicateProcessor,
                fn: 'duplicateModel'
            },
            [_Jobs.JobTypes.DuplicateColumn]: {
                this: this.duplicateProcessor,
                fn: 'duplicateColumn'
            },
            [_Jobs.JobTypes.AtImport]: {
                this: this.atImportProcessor
            },
            [_Jobs.JobTypes.MetaSync]: {
                this: this.metaSyncProcessor
            },
            [_Jobs.JobTypes.MetaDiff]: {
                this: this.metaSyncProcessor,
                fn: 'metaDiffJob'
            },
            [_Jobs.JobTypes.SourceCreate]: {
                this: this.sourceCreateProcessor
            },
            [_Jobs.JobTypes.SourceDelete]: {
                this: this.sourceDeleteProcessor
            },
            [_Jobs.JobTypes.HandleWebhook]: {
                this: this.webhookHandlerProcessor
            },
            [_Jobs.JobTypes.DataExport]: {
                this: this.dataExportProcessor
            },
            [_Jobs.JobTypes.DataExportCleanUp]: {
                this: this.dataExportCleanUpProcessor
            },
            [_Jobs.JobTypes.ThumbnailGenerator]: {
                this: this.thumbnailGeneratorProcessor
            },
            [_Jobs.JobTypes.AttachmentCleanUp]: {
                this: this.attachmentCleanUpProcessor
            },
            [_Jobs.JobTypes.InitMigrationJobs]: {
                this: this.initMigrationJobs
            },
            [_Jobs.JobTypes.UseWorker]: {
                this: this.useWorkerProcessor
            },
            [_Jobs.JobTypes.AttachmentUrlUpload]: {
                this: this.attachmentUrlUploadProcessor
            }
        };
    }
    get jobs() {
        return this._jobMap;
    }
    constructor(duplicateProcessor, atImportProcessor, metaSyncProcessor, sourceCreateProcessor, sourceDeleteProcessor, webhookHandlerProcessor, dataExportProcessor, thumbnailGeneratorProcessor, attachmentCleanUpProcessor, initMigrationJobs, useWorkerProcessor, dataExportCleanUpProcessor, attachmentUrlUploadProcessor){
        this.duplicateProcessor = duplicateProcessor;
        this.atImportProcessor = atImportProcessor;
        this.metaSyncProcessor = metaSyncProcessor;
        this.sourceCreateProcessor = sourceCreateProcessor;
        this.sourceDeleteProcessor = sourceDeleteProcessor;
        this.webhookHandlerProcessor = webhookHandlerProcessor;
        this.dataExportProcessor = dataExportProcessor;
        this.thumbnailGeneratorProcessor = thumbnailGeneratorProcessor;
        this.attachmentCleanUpProcessor = attachmentCleanUpProcessor;
        this.initMigrationJobs = initMigrationJobs;
        this.useWorkerProcessor = useWorkerProcessor;
        this.dataExportCleanUpProcessor = dataExportCleanUpProcessor;
        this.attachmentUrlUploadProcessor = attachmentUrlUploadProcessor;
    }
};
JobsMap = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _duplicateprocessor.DuplicateProcessor === "undefined" ? Object : _duplicateprocessor.DuplicateProcessor,
        typeof _atimportprocessor.AtImportProcessor === "undefined" ? Object : _atimportprocessor.AtImportProcessor,
        typeof _metasyncprocessor.MetaSyncProcessor === "undefined" ? Object : _metasyncprocessor.MetaSyncProcessor,
        typeof _sourcecreateprocessor.SourceCreateProcessor === "undefined" ? Object : _sourcecreateprocessor.SourceCreateProcessor,
        typeof _sourcedeleteprocessor.SourceDeleteProcessor === "undefined" ? Object : _sourcedeleteprocessor.SourceDeleteProcessor,
        typeof _webhookhandlerprocessor.WebhookHandlerProcessor === "undefined" ? Object : _webhookhandlerprocessor.WebhookHandlerProcessor,
        typeof _dataexportprocessor.DataExportProcessor === "undefined" ? Object : _dataexportprocessor.DataExportProcessor,
        typeof _thumbnailgeneratorprocessor.ThumbnailGeneratorProcessor === "undefined" ? Object : _thumbnailgeneratorprocessor.ThumbnailGeneratorProcessor,
        typeof _attachmentcleanup.AttachmentCleanUpProcessor === "undefined" ? Object : _attachmentcleanup.AttachmentCleanUpProcessor,
        typeof _initmigrationjobs.InitMigrationJobs === "undefined" ? Object : _initmigrationjobs.InitMigrationJobs,
        typeof _useworkerprocessor.UseWorkerProcessor === "undefined" ? Object : _useworkerprocessor.UseWorkerProcessor,
        typeof _dataexportcleanupprocessor.DataExportCleanUpProcessor === "undefined" ? Object : _dataexportcleanupprocessor.DataExportCleanUpProcessor,
        typeof _attachmenturluploadprocessor.AttachmentUrlUploadProcessor === "undefined" ? Object : _attachmenturluploadprocessor.AttachmentUrlUploadProcessor
    ])
], JobsMap);
